import { render, staticRenderFns } from "./userCardBrowsingHistory.vue?vue&type=template&id=f765c662&scoped=true"
import script from "./userCardBrowsingHistory.vue?vue&type=script&lang=js"
export * from "./userCardBrowsingHistory.vue?vue&type=script&lang=js"
import style0 from "./userCardBrowsingHistory.vue?vue&type=style&index=0&id=f765c662&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f765c662",
  null
  
)

export default component.exports